import {TaxAccountantConsultationForm, TaxAccountantConsultationGrid} from "@/features/manage";
import {filterValidValuesToObject} from "@/shared/lib";
import {vars} from "@/shared/lib/theme.css";
import {TaxAccountantConsultationSearchType} from "@/shared/model";
import {Column, Indicator} from "@/shared/ui";
import {createFileRoute} from "@tanstack/react-router";
import {Suspense} from "react";

export const Route = createFileRoute("/(auth)/_layout/manage/tax-accountant-consultation/")({
	component: TaxManageScreen,
	validateSearch: (
		search: Partial<TaxAccountantConsultationSearchType>
	): Partial<TaxAccountantConsultationSearchType> => {
		return filterValidValuesToObject<TaxAccountantConsultationSearchType, TaxAccountantConsultationSearchType>(search);
	}
});

function TaxManageScreen() {
	return (
		<Column fullWidth style={{gap: vars.size[16]}}>
			<Column
				fullWidth
				style={{
					position: "sticky",
					top: 0,
					zIndex: 100,
					backgroundColor: vars.color.white,
					paddingBottom: vars.size[16]
				}}
			>
				<TaxAccountantConsultationForm />
			</Column>
			<Suspense fallback={<Indicator />}>
				<TaxAccountantConsultationGrid />
			</Suspense>
		</Column>
	);
}
